/**
 * Example module script
 *
 */

// Make sure '$' is set
var $ = jQuery;

/**
 * Initialize module code
 *
 */
var init = function () {

	embedVideoHandler();

};

/**
 * Bind event handlers
 *
 * Only used for legacy pages
 *
 * @link http://v4-alpha.getbootstrap.com/components/modal/#events
 */
var bindHandlers = function () {
	// Bind to modal toggle links
	$('[data-toggle="modal"]').on('click', openModalHandler);
	// Bind on bs close event (see link above for more details)
	$('.js-video-modal').on('hidden.bs.modal', closeModalHandler);
};

var openModalHandler = function (e) {
	// Set vars
	var modalID,
		$iframe,
		src;

	// Get modal id.
	modalID = $(this).data('target');$(this).data('target');

	// Get iframe from target video modal element
	$iframe = $(modalID+'.js-video-modal iframe').first();
	// If there is iframe, update src
	if ( $iframe.length > 0 ) {
		// Get video src
		src = 'https://www.youtube-nocookie.com/embed/' + $iframe.data('embed') +'?rel=0&autoplay=1' + $iframe.data('attributes');
		// Add src to iframe
		$iframe.attr('src', src);
	}
};

var closeModalHandler = function (e) {
	// Get iframe element from modal
	var $iframe = $(e.target).find('iframe');
	// Remove src attr
	$iframe.attr('src', '');
};

var embedVideoHandler = function (e) {
	var youtube = document.querySelectorAll( ".js-video-embed" );
	for (var i = 0; i < youtube.length; i++) {

		var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/maxresdefault.jpg";

		var image = new Image();
		image.src = source;
		image.addEventListener( "load", function() {
			youtube[ i ].appendChild( image );
		}( i ) );

		youtube[i].addEventListener( "click", function() {

			var iframe = document.createElement( "iframe" );

			iframe.setAttribute( "frameborder", "0" );
			iframe.setAttribute( "allowfullscreen", "" );
			iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

			this.innerHTML = "";
			this.appendChild( iframe );
		} );
	}
};

// Functions to reveal
exports.init = init;
exports.bindHandlers = bindHandlers;
